// extracted by mini-css-extract-plugin
export default {"edge":"RightSideBar_edge__Y6dk5"};